import { render, staticRenderFns } from "./EvalQuestionReceipt.vue?vue&type=template&id=a6572b92&scoped=true&"
import script from "./EvalQuestionReceipt.vue?vue&type=script&lang=js&"
export * from "./EvalQuestionReceipt.vue?vue&type=script&lang=js&"
import style0 from "./EvalQuestionReceipt.vue?vue&type=style&index=0&id=a6572b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6572b92",
  null
  
)

export default component.exports